// extracted by mini-css-extract-plugin
export var standaloneTable = "_gc-0";
export var withExtraHeader = "_gc-1";